import { app } from '../../../../../app';
import { Controller } from './hard-token-users.controller';

app.component('companyUserDirectoriesSaaspassUsersHardTokenUsers', {
    bindings: {
        blockedUsers: '<',
        companyUsers: '<',
        hardTokens: '<',
    },
    controller: Controller,
    templateUrl: require('./hard-token-users.html'),
});



// WEBPACK FOOTER //
// ./src/portal/states/company/user-directories/saaspass-users/hard-token-users/hard-token-users.component.js